import * as React from "react"

import { Container, Row, Col, Button } from "shards-react"
import { Img } from "react-image"
import Carousel from "react-bootstrap/Carousel"

import ProgrammePreview from "../components/programmePreview"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

// Images & Videos
import CSECVideo from "../videos/csec.mp4"
import StudentImage from "../images/student.jpg"

import { getCountry } from "../js/getCountry"

// Logos
import CSECLogo from "../logos/csec"
import CAPELogo from "../logos/cape"
import IELTSLogo from "../logos/ielts"
import SATLogo from "../logos/sat"
import DELFLogo from "../logos/delf"
import DELELogo from "../logos/dele"

class FindProgram extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      routes: require("../data/routes.json"),
      country: getCountry(this.props.countryCode)
    }

    this.routify = this.routify.bind(this)
  }

  routify(url) {
    return "/" + this.state.country.slug + url
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <Row>
          <Col md={6}>
            <img src={StudentImage} style={{ width: "100%" }} />
          </Col>
          <Col md={6} className="pt-4">
            <Container>
              <MobileView>
                <br />
              </MobileView>

              <h4 className="text-center">
                Take your qualifications to the next level
              </h4>

              <p className="text-center p-1">
                Choose from over 13 programmes across a variety of academic
                disciplines
              </p>

              <Row>
                <Col xs={4}>
                  <a href={this.routify(this.state.routes.csec)}>
                    <CSECLogo lg />
                  </a>
                </Col>
                <Col xs={4}>
                  <a href={this.routify(this.state.routes.cape)}>
                    <CAPELogo lg />
                  </a>
                </Col>
                <Col xs={4}>
                  <a href={this.routify(this.state.routes.sat)}>
                    <SATLogo lg />
                  </a>
                </Col>
              </Row>

              <br />
              <br />
              <Button
                href={this.routify(this.state.routes.programmes)}
                className="center"
                style={{ width: "75%" }}
              >
                Find a Programme
              </Button>
            </Container>
          </Col>
        </Row>
        <br />
      </div>
    )
  }
}

export default FindProgram
